import styled from 'styled-components'

export const StyledStatsCard = styled.div`
	border-radius: 5px;
	border: 1px solid #CDCDCD;
	background-color: white;
	position: relative;
	width: fit-content;
	& .stats_card{
		height: 50px;
		display: flex;
		align-items: center;
		& .tablet_icon{
			display: none;
		}
	}

	& .stats_card__label{
		color: #B0B0B0;
		display: flex;
		align-items: center;
		font-size: 12px;
		font-weight: 500;
	}

	& .stats_card__label_value {
		color: ${({ textColor }) => textColor ? textColor : 'purple'};
		& .stats_card__value_highlighted {
			display: inline-block;
			margin-left: 5px;
			background-color: #8DDBCD;
			opacity: 0.75;
			color: white;
			width: ${({ isNumberBig }) => isNumberBig ? '20px' : '15.8px' };
			line-height: 15.8px;
			border-radius: 50%;
			text-align: center;
		}
		@media (min-width: 1200px){
			& .stats_card__value_highlighted {
				width: ${({ isNumberBig }) => isNumberBig ? '20px' : '21px' };
				line-height: 20px;
			}
		}
	}

	& .stats_card__value{
		font-size: 19px;
		font-weight: 700;
		display: flex;
    	align-items: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&.totalStat{
		min-width: 182px;
		order: 1;
		& .stats_card__currency{
			color: ${({ textColor }) => textColor ? textColor : 'purple'};
			position: absolute;
			top: 8px;
    		right: 14px;
			font-size: 15px;
			font-weight: 700;
		}
	}

	&.totalKStat{
		min-width: 172px;
		order: 2;
	}

	&.billCountStat{
		min-width: 114px;
		order: 3;
	}

	&.cashRegistersStat{
		min-width: 146px;
		order: 4;
	}

	@media (max-width: 1200px){
		&.stats_wrapper{
			width: 100%;
			min-width: auto;
		}

		&.totalStat .stats_card__currency{
			top: 6px;
			right: 11px;
			font-size: 12px;
			font-weight: 700;
		}

		&.totalKStat{
			order: 3;
		}

		&.billCountStat{
			order: 2;
		}

		& .stats_card{
			height: 40px;
			& .tablet_icon{
				display: block;
			}
			& .computer_icon{
				display: none;
			}
		}

		& .stats_card__label{
			font-size: 10px;
		}

		& .stats_card__value{
			font-size: 15px;
		}
	}

	@media (max-width: 768px){
		width: 126px;
		padding-left: 10px;

		&.totalStat .stats_card__currency{
			top: 7px;
			right: 10px;
			font-size: 11px;
			font-weight: 600;
		}

		& .stats_card{
			height: 46px;
			& .tablet_icon{
				display: none;
			}
		}

		& .stats_card__label{
			font-size: 12px;
		}
	}

	@media (max-width: 625px){
		width: auto;
		overflow: hidden;
		& .stats_card__label{
			font-size: 9px;
		}

		& .stats_card__value{
			font-size: 14px;
			width: 110px;
		}
	}

	@media (max-width: 512px){
		&.totalStat .stats_card__currency{
			font-size: 10px;
		}
		& .stats_card{
			height: 40px;
		}
		& .stats_card__value{
			font-size: 13px;
			width: 90px;
		}
	}

	@media (max-width: 464px){
		& .stats_card__label{
			font-size: 8px;
		}
		& .stats_card__value{
			font-size: 12px;
			width: 70px;
		}
	}

	@media (max-width: 416px){
		&.totalStat .stats_card__currency{
			font-size: 9px;
		}
		& .stats_card{
			height: 35px;
		}
		& .stats_card__label{
			font-size: 7px;
		}
		& .stats_card__value{
			font-size: 11px;
			width: 60px;
		}
	}

	@media (max-width: 378px){
		&.totalStat .stats_card__currency{
			font-size: 8px;
			top: 4px;
		}
		& .stats_card{
			height: 30px;
		}
		& .stats_card__label{
			font-size: 6px;
		}
	}

	@media (max-width: 350px){
		& .stats_card__value{
			width: 50px;
		}
	}

	@media (max-width: 335px){
		&.totalStat .stats_card__currency{
			font-size: 6px;
		}
		& .stats_card__label{
			font-size: 5px;
		}
	}
`
